export default "__VITE_ASSET__CiVhFiv9__"